import { Box, Stack, Typography } from "@mui/material";
import { useQueryMedia } from "../../../../hooks/useQueryMedia";
import Colors from "../../../../utils/Colors";
import Images from "../../../../utils/Images";
import { CreateImage } from "./HowItWorkComponents";

export default function HowItWorkTeacher() {
  const { isMobile, isSmall, isExtraSmall, isMedium, isLarge } = useQueryMedia();
  return (
    <Stack spacing={2} sx={{ color: "white", pb: 2 }}>
      <Wrapper>
        {isMobile ? (
          <>
            <CreateTitleMob title={PAGE_DATA.CREATING_LECTURES.title} />
            <CreateTextMob>{PAGE_DATA.CREATING_LECTURES.text}</CreateTextMob>
          </>
        ) : (
          <>
            <CreateTitleWeb title={PAGE_DATA.CREATING_LECTURES.title} />
            <CreateTextWeb>{PAGE_DATA.CREATING_LECTURES.text}</CreateTextWeb>
          </>
        )}
      </Wrapper>

      <Wrapper>
        {isMobile ? (
          <>
            <CreateTitleMob title={PAGE_DATA.JUST_BEFORE_CLASS.title} />
            <CreateTextMob>
              {PAGE_DATA.JUST_BEFORE_CLASS.text1}
              <br />
              <br />
              {PAGE_DATA.JUST_BEFORE_CLASS.text2}
              <br />
              <br />
              {PAGE_DATA.JUST_BEFORE_CLASS.text3}
            </CreateTextMob>
          </>
        ) : (
          <>
            <CreateTitleWeb title={PAGE_DATA.JUST_BEFORE_CLASS.title} />
            <CreateTextWeb>
              {PAGE_DATA.JUST_BEFORE_CLASS.text1}
              <br />
              <br />
              {PAGE_DATA.JUST_BEFORE_CLASS.text2}
              <br />
              <br />
              {PAGE_DATA.JUST_BEFORE_CLASS.text3}
            </CreateTextWeb>
          </>
        )}
      </Wrapper>

      <Wrapper>
        {isMobile ? (
          <>
            <CreateTitleMob title={PAGE_DATA.STUDENT_TEACHER_INTERACTION.title} />
            <CreateImage width={17} image={Images.NEW_REMOTE_MOB} />
            <CreateTextMob>
              {PAGE_DATA.STUDENT_TEACHER_INTERACTION.text1}
              <br />
              <br />
              {PAGE_DATA.STUDENT_TEACHER_INTERACTION.text2}
            </CreateTextMob>
          </>
        ) : (
          <Stack direction="row" spacing={1}>
            <CreateImageWeb width={18} image={Images.NEW_REMOTE_WEB} />
            <Stack spacing={1}>
              <CreateTitleWeb title={PAGE_DATA.STUDENT_TEACHER_INTERACTION.title} />
              <CreateTextWeb>{PAGE_DATA.STUDENT_TEACHER_INTERACTION.text1}</CreateTextWeb>
              <CreateTextWeb>{PAGE_DATA.STUDENT_TEACHER_INTERACTION.text2Web}</CreateTextWeb>
            </Stack>
          </Stack>
        )}
      </Wrapper>

      <Wrapper>
        {isMobile ? (
          <>
            <CreateTitleMob title={PAGE_DATA.VIEWING_RESPONSES.title} />
            <CreateTextMob>{PAGE_DATA.VIEWING_RESPONSES.text1} </CreateTextMob>
            <Box display="flex" py={1} alignItems="center" justifyContent="center">
              <CreateImage width={isExtraSmall ? 30 : isSmall ? 45 : 60} image={Images.NEW_VIEW_PDF} />
            </Box>
            <CreateTextMob>{PAGE_DATA.VIEWING_RESPONSES.text2}</CreateTextMob>
            <Box display="flex" pt={1} alignItems="center" justifyContent="center">
              <CreateImage width={isExtraSmall ? 30 : isSmall ? 45 : 60} image={Images.NEW_VIEW_REMOTE} />
            </Box>
          </>
        ) : (
          <>
            <CreateTitleWeb title={PAGE_DATA.VIEWING_RESPONSES.title} />
            <Stack direction="row" spacing={1}>
              <Box flex={1} textAlign="left" alignContent="center">
                <CreateTextWeb>{PAGE_DATA.VIEWING_RESPONSES.text1} </CreateTextWeb>
              </Box>
              <Box display="flex" pt={1} alignItems="center" justifyContent="center">
                <CreateImageWeb width={isExtraSmall ? 30 : isSmall ? 40 : 50} image={Images.NEW_VIEW_PDF} />
              </Box>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Box display="flex" pt={1} alignItems="center" justifyContent="center">
                <CreateImageWeb width={isExtraSmall ? 30 : isSmall ? 40 : 50} image={Images.NEW_VIEW_REMOTE} />
              </Box>
              <Box flex={1} textAlign="left" alignContent="center">
                <CreateTextWeb>{PAGE_DATA.VIEWING_RESPONSES.text2} </CreateTextWeb>
              </Box>
            </Stack>
          </>
        )}
      </Wrapper>

      <Wrapper>
        {isMobile ? (
          <>
            <CreateTitleMob title={PAGE_DATA.ANALYTICS.title} />
            <CreateTextMob>{PAGE_DATA.ANALYTICS.text}</CreateTextMob>
            <Box display="flex" pt={1} alignItems="center" justifyContent="center">
              <CreateImage width={isExtraSmall ? 30 : isSmall ? 45 : 60} image={Images.NEW_STATS_PREVIEW} />
            </Box>
          </>
        ) : (
          <Stack direction="row" spacing={1}>
            <Stack>
              <CreateTitleWeb title={PAGE_DATA.ANALYTICS.title} />
              <Box flex={1} textAlign="left" alignContent="center">
                <CreateTextWeb>{PAGE_DATA.ANALYTICS.text}</CreateTextWeb>
              </Box>
            </Stack>
            <Box display="flex" pt={1} alignItems="center" justifyContent="center">
              <CreateImageWeb width={isExtraSmall ? 30 : isSmall ? 45 : 60} image={Images.NEW_STATS_PREVIEW} />
            </Box>
          </Stack>
        )}
      </Wrapper>
    </Stack>
  );
}

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      border: "1px solid " + Colors.LIGHT_BLUE_HEADER,
      borderRadius: "15px",
      padding: 2,
    }}
  >
    {children}
  </Box>
);

const CreateTitleMob = ({ title }: { title: string }) => (
  <Typography textAlign="center" pb={1} fontWeight="bold" color={Colors.ANSWER} variant="body2">
    {title}
  </Typography>
);
const CreateTitleWeb = ({ title, textAlign }: { title: string; textAlign?: any }) => (
  <Typography textAlign={textAlign ?? "left"} pb={1} fontWeight="bold" color={Colors.ANSWER} variant="body1">
    {title}
  </Typography>
);

const CreateTextMob = ({ children }: any) => <Typography fontSize={12}>{children}</Typography>;
const CreateTextWeb = ({ children }: any) => <Typography fontSize={14}>{children}</Typography>;

const CreateImageWeb = ({ width, image, responseWidth }: { width?: number | string; image: string; responseWidth?: object }) => (
  <Box component="img" sx={{ float: "left", maxWidth: responseWidth ? responseWidth : `${width}vh`, objectFit: "contain" }} alt="???" src={image} />
);

const PAGE_DATA = {
  CREATING_LECTURES: {
    title: "Creating lectures",
    text: "Once you register as a teacher, you can create a course and corresponding lectures. For each lecture, you can upload your presentation. Currently, our platform supports only the PDF format. Please use a preview option to make sure that the presentation is correctly uploaded and can be viewed. We respect your privacy, and we don’t share presentations with anyone. You can delete your presentations at any time.",
  },
  JUST_BEFORE_CLASS: {
    title: "Just before the class starts",
    text1:
      "Only students that are present at a lecture (either virtually or physically) can get a pseudonym for that lecture. At the beginning of the lecture, you should request a Lecture Code and share it with students. Students that already have a PrivateID should use it to login. Students that are joining the platform for the first time, should register and obtain their PrivateID and the password.",
    text2:
      " Please carefully monitor the number of issued PrivateIDs and pseudonyms. If for example, the number of issued pseudonyms is larger than the number of the students attending the lecture, you should reset the pseudonyms and re-issue pseudonyms. The reset action deletes all the pseudonyms issued for that lecture.",
    text3: " It is recommended that you keep the list of students that have already registered and allow students to register only during the first few lectures.",
  },
  STUDENT_TEACHER_INTERACTION: {
    title: "Student-Teacher Interaction",
    text1:
      "The main mode of interaction during the class is through the interface that resembles the remote control. It provides an anonymous and real-time feedback to the teacher so that the teacher can get a pulse of students’ understanding of the material that is presented. To make sure that the students’ responses are minimally disruptive, the option to post questions, answers, or engage in discussions is disabled during the lecture.",
    text2:
      "However, the teacher can enable it at any time. Another mode of interaction is through questions-answers-discussions (Q/A/Ds). This mode of interaction can be conducted both during and after the lecture. A student can make a post only under a pseudonym. A teacher can make a post either as a teacher or under a pseudonym in order to better understand students.",
    text2Web:
      "Another mode of interaction is through questions-answers-discussions (Q/A/Ds). This mode of interaction can be conducted both during and after the lecture. A student can make a post only under a pseudonym. A teacher can make a post either as a teacher or under a pseudonym in order to better understand students.",
  },
  VIEWING_RESPONSES: {
    title: "Viewing Responses",
    text1:
      "If the teacher is using the slides, the students’ responses are displayed in real-time in the bar under the slide. The size of each color/section is proportional to the number of responses.",
    text2: "If the teacher is not using the slides, the responses are displayed on the remote control. This remote is not an interface, since the buttons only show students’ response.",
  },
  ANALYTICS: {
    title: "Analytics",
    text: "The platform continuously records feedback from every student during the lecture and creates a histogram of students’ responses - feedback statistics. Teachers can use various tools such as AI to analyze statistics and make changes to the lecture.",
  },
};
